import Tokens from "./tokens";

export default Tokens;
